import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { ConfigSession, ConfigSessionService } from './interfaces/config-session.service';
import { CookieService } from 'ngx-cookie-service';
import { SessionService } from './session.service';
import { BsModalService } from 'ngx-bootstrap/modal';


@NgModule({
  imports: [CommonModule],
  declarations: [],
  providers: [SessionService, CookieService, BsModalService]
})
export class SessionServiceModule {
  static forRoot(configSession: ConfigSessionService | ConfigSession): ModuleWithProviders<any> {
    return {
      ngModule: SessionServiceModule,
      providers: [
        // Crea provider ConfigSessionService, con su configuración para ser inyectado en el session service
        { provide: ConfigSessionService, useValue: configSession }
      ]
    };
  }
}
